// pilotMutationApi.js — service du module « Pilot Mutation » (cockpit migration WP)
import axios from 'axios';

const token = () => localStorage.getItem('oracle_token');
const H = () => ({ Authorization: `Bearer ${token()}` });
const base = (projectId) => `/api/projects/${projectId}/pilot-mutation`;

export const pilotMutationApi = {
  // Dashboard : { connected, site, stats, progress }
  async overview(projectId) {
    const { data } = await axios.get(`${base(projectId)}/overview`, { headers: H() });
    return data;
  },
  // Table : { items, total, limit, offset }
  async items(projectId, params = {}) {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== '' && v != null));
    const { data } = await axios.get(`${base(projectId)}/items`, { headers: H(), params: clean });
    return data;
  },
  // Relance l'inventaire (persiste) : { ok, status, summary, error }
  async refresh(projectId) {
    const { data } = await axios.post(`${base(projectId)}/refresh`, {}, { headers: H() });
    return data;
  },
  // Aperçu nettoyé d'un item (read-only) : { ok, preview: { title, html_clean, is_elementor, old_url, word_count }, error }
  async preview(projectId, itemId) {
    const { data } = await axios.post(`${base(projectId)}/preview`, { item_id: itemId }, { headers: H() });
    return data;
  },
  // L'Intégrateur : importe un lot vers project_files : { ok, summary, items, message, error }
  async importBatch(projectId, ids) {
    const { data } = await axios.post(`${base(projectId)}/import`, { ids }, { headers: H() });
    return data;
  },
  // Tour A : republie un lot d'items importés vers le site cible : { ok, summary, items, message, error }
  async republish(projectId, ids, rubrique) {
    const body = rubrique ? { ids, rubrique } : { ids };
    const { data } = await axios.post(`${base(projectId)}/republish`, body, { headers: H() });
    return data;
  },
  // Base des redirections 301 (old_url → new_url des items migrés) : { ok, redirects, message }
  async redirects(projectId) {
    const { data } = await axios.get(`${base(projectId)}/redirects`, { headers: H() });
    return data;
  },
};

export default pilotMutationApi;
